import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import Modal from "react-modal";
import { Translate } from "react-redux-i18n";
import Constants from "../../AppConstants/Constants";
import { updateWizardInProgressModalState } from "../../Store/Modals/Actions";
import { updateTempCart } from "../../Store/Cart/Actions";
import { updateCurrentStep, goFirst } from "../../Store/Wizard/Actions";
import { updateKitQuantity, updateDeviceQuantity } from "../../Store/Catalog/Actions";
import constants from "../../Chat/constants";
Modal.setAppElement("#react-app");

class WizardInProgressModal extends Component {
    constructor(props) {
        super(props);

        this.closeModal = this.closeModal.bind(this);
        this.onContinue = this.onContinue.bind(this);
    }

    closeModal() {
        const { updateWizardInProgressModalState } = this.props;

        updateWizardInProgressModalState(false);
    }

    onContinue(path) {
        const { updateTempCart, updateCurrentStep, history, updateKitQuantity, updateDeviceQuantity, updateWizardInProgressModalState, wizardInProgressModalData, goFirst } = this.props;

        updateWizardInProgressModalState(false);
        updateTempCart();
        updateCurrentStep(0);
        updateKitQuantity(1);
        updateDeviceQuantity(1);
        history.push(wizardInProgressModalData.url || Constants.ENDPOINTS.HOME);
        // if user clicks on tab for same kit page they are already on, reset the wizard to the first step
        if (wizardInProgressModalData.name === "Build Kit" && path === Constants.ENDPOINTS.BUILD_A_KIT) {
            goFirst("KitsBuild");
        } else if (wizardInProgressModalData.name === "Shop Kits" && path === Constants.ENDPOINTS.KITS) {
            goFirst("Kits");
        } else if (wizardInProgressModalData.name === "Devices" && path === Constants.ENDPOINTS.DEVICES) {
            goFirst("Devices");
        }
    }

    render() {
        const { wizardInProgressModalOpen, wizardInProgressModalData } = this.props;
        const path = window.location.pathname;
        return (
            <Modal
                isOpen={wizardInProgressModalOpen}
                onRequestClose={this.closeModal}
                contentLabel="create account alert"
                className="modal-content"
                overlayClassName="modal-container create-account-modal modal-active"
            >
                <div className="modal-body wizard-in-progress-body">
                    <div className="row justify-content-center">
                        <div className="col-md-12 text-center">
                            <div className="feature feature-1">
                                <div className="text-block">
                                    <h3><Translate value="modals.wizardInProgress.title" /></h3>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <button className="btn btn--primary type--uppercase continue-button" type="button" onClick={ () => this.onContinue(path)}><Translate value="modals.wizardInProgress.yes" /></button>
                                        <button className="btn btn--primary type--uppercase cancel-button" type="button" onClick={this.closeModal}><Translate value="modals.wizardInProgress.no" /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        wizardInProgressModalOpen: state.wizardInProgressModalOpen,
        wizardInProgressModalData: state.wizardInProgressModalData
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateWizardInProgressModalState: updateWizardInProgressModalState,
        updateTempCart: updateTempCart,
        updateCurrentStep: updateCurrentStep,
        updateKitQuantity: updateKitQuantity,
        updateDeviceQuantity: updateDeviceQuantity,
        goFirst: goFirst
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WizardInProgressModal));